export interface JobItem {
  id: string;
  title: string;
  company: string;
  period?: string;
  responsibilities?: string;
  skillIds: string[];
}

export const jobs: JobItem[] = [
  {
    id: "brokeria",
    title: "jobs.titles.brokeria",
    company: "jobs.companies.brokeria",
    period: "jobs.periods.brokeria",
    responsibilities: "jobs.responsibilities.brokeria",
    skillIds: [
      "php",
      "laravel",
      "vue",
      "mysql",
      "html",
      "css",
      "tailwind",
      "js",
      "jquery",
      "gitlab",
      "docker",
      "macos",
      "rest",
      "solid",
    ],
  },
  {
    id: "pontis",
    title: "jobs.titles.pontis",
    company: "jobs.companies.pontis",
    period: "jobs.periods.pontis",
    responsibilities: "jobs.responsibilities.pontis",
    skillIds: [
      "php",
      "laravel",
      "mysql",
      "postgresql",
      "html",
      "css",
      "tailwind",
      "js",
      "jquery",
      "alpine",
      "gitlab",
      "docker",
      "macos",
      "solid",
    ],
  },
  {
    id: "profesia",
    title: "jobs.titles.profesia",
    company: "jobs.companies.profesia",
    period: "jobs.periods.profesia",
    responsibilities: "jobs.responsibilities.profesia",
    skillIds: [
      "php",
      "symfony",
      "mysql",
      "html",
      "css",
      "js",
      "jquery",
      "sass",
      "vue",
      "gitlab",
      "docker",
      "macos",
      "elasticsearch",
      "rest",
      "solid",
      "ddd",
    ],
  },
  {
    id: "monogram",
    title: "jobs.titles.monogram",
    company: "jobs.companies.monogram",
    period: "jobs.periods.monogram",
    responsibilities: "jobs.responsibilities.monogram",
    skillIds: [
      "php",
      "symfony",
      "mysql",
      "html",
      "css",
      "js",
      "jquery",
      "sass",
      "elasticsearch",
      "rest",
      "gitlab",
    ],
  },
  {
    id: "mhg",
    title: "jobs.titles.mhg",
    company: "jobs.companies.mhg",
    skillIds: [],
  },
];
